<template>
  <div>
    <!--Banner-->
    <div class="banner-section">
      <Slider :items="sliders" />
    </div>
    <!--Banner-->

    <!--Search Provider-->
    <!-- <div class="search-provider pt-60">
      <div class="container-fluid">
        <div class="search-provider-wrapper">
          <div
            class="left-select-bar src-provider flex-wrap d-flex align-items-center"
          >
            <div class="step-one">
              <select name="select-one" id="select1" @change="resetSearch">
                <option v-for="category in categories" :key="category.id" :value="category.slug">
                  {{ category.name }}
                </option>
              </select>
              <span class="seven-icon"
                ><img src="@/assets/img/play/seven.svg" alt="play-img"
              /></span>
            </div>
            <div class="step-two">
              <select name="select-one" id="select">
                <option value="1">Game types</option>
                <option value="1">Supper Power</option>
                <option value="1">Princes</option>
              </select>
              <span class="seven-icon"
                ><img src="@/assets/img/play/bars.png" alt="play-img"
              /></span>
            </div>
          </div>
          <div class="right-search">
            <form action="#">
              <input type="text" placeholder="Search..." v-bind="search" onchange="resetSearch" />
              <div class="search">
                <i class="fas fa-magnifying-glass"></i>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div> -->
    <!--Search Provider-->

    <!--Crime-->
    <div class="crime-section pt-60 pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("Featured Games") }}</h2>
        </div>
        <div class="crime-wrapper">
          <MostViews :items="newGames" />
        </div>
      </div>
    </div>
    <!--Crime-->

    <!--Casino Demo-->
    <div class="casino-demo pb-60 pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("All games") }}</h2>
          <!-- <a href="javascript:;" class="border-btn">
            <span> All games</span>
          </a> -->
        </div>
        <div class="all-games-wrapper">
          <div class="row g-3">
            <div v-for="game in games" :key="game.id" class="col-xxl-3 col-xl-4 col-md-4 col-sm-6">
              <GameCard :game="game" />
            </div>
          </div>
        </div>
      </div>
      <div class="more-btn text-center bt" v-if="nextPage != null">
        <a href="javascript:;" class="border-btn" @click="loadMore">
          <span>{{ $t("Load more") }}</span>
        </a>
      </div>
    </div>
    <!--Casino Demo-->
  </div>
</template>

<script>
import { useGamesStore } from "@/store/games";
import { mapState, mapActions } from "pinia";
import MostViews from "@/components/partials/GameRowSlider.vue";
import Slider from "@/components/partials/Slider.vue";
import GameCard from "@/components/partials/GameCard.vue";

export default {
  name: "GamesPage",
  components: {
    MostViews,
    Slider,
    GameCard,
  },
  computed: {
    ...mapState(useGamesStore, ["games", "nextPage", "newGames", "sliders"]),
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions(useGamesStore, ["loadAllGames"]),
    async loadMore() {
      await this.loadAllGames();
    },
    async resetSearch() {
      this.nextPage = 1;
      await this.loadAllGames();
    },
  },
  async mounted() {
    this.nextPage = 1;
    await this.loadAllGames();
  },
};

</script>
